import logo from "../assets/logo.png";
import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <img className="footer-logo" src={logo} alt="The New Mainstream" />

        <address className="footer-contact-info">
          <span>mccsa@mccsa.org.au</span>
          <br />
          <span>8345 5266</span>
          <br />
          <span>113 Gilbert Street</span>
          <br />
          <span>Adelaide SA 5000</span>
        </address>
      </div>
      <a className="footer-privacy" href="https://mccsa.org.au/privacy-policy/">
        Privacy Policy
      </a>
      <br />
      <a className="footer-MCCSA" href="https://mccsa.org.au/">
        MCCSA
      </a>
      <br />
      <a className="footer-culturalQ" href="https://mccsa.org.au/culturalq/">
        CulturalQ
      </a>

      <div className="footer-acknowledgement">
        <p>
          <strong>The New Mainstream</strong> respectfully acknowledges the
          Traditional Owners of Country throughout Australia and recognises
          their continuing connection to land, waters and community. We pay our
          respects to Aboriginal and Torres Strait Islander peoples, their
          cultures, and their Elders past and present.
        </p>
        <p>
          We honour the strength, resilience and enduring knowledge of
          Aboriginal and Torres Strait Islander peoples, and commit to walking
          alongside them in the shared journey of truth, healing and
          reconciliation.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
